<mat-card>
    <!-- feature workflow expanded view component -->
    <mat-tab-group [selectedIndex]="0">
        <mat-tab label="Configuration and arguments">
            <!-- <app-config-arguments-card [data]="data" [wfId]="wfId" [wfhId]="wfhId"></app-config-arguments-card> -->
        </mat-tab>

        <mat-tab label="Tools and thresholds">
            <!-- <app-tools-threshold-card [wfId]="wfId" [wfhId]="wfhId"></app-tools-threshold-card> -->
        </mat-tab>
    </mat-tab-group>

    <!--Save and cancel buttons-->
    <div class="button-alignment">
        <!-- <button mat-raised-button *ngIf="mode == 'add'" color="primary" class="btn-space" type="submit"> Save </button> -->
        <button mat-raised-button *ngIf="mode == 'edit'" color="primary" class="btn-space" type="submit"> Update
        </button>
        <button mat-raised-button *ngIf="mode == 'add' || mode == 'edit'" color="red" class="btn-space"> Cancel
        </button>
    </div>

</mat-card>